export default "__VITE_ASSET__COzkvaTi__"